import React from 'react';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBackButton from '@/component/common/top-back-button';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import SFMenu from '@/component/my/sf-menu';
import { SFPalette } from '@/lib/color';
import Stack from '@mui/material/Stack';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { boardList, boardListProps, resNoticeListProps } from '@/api/server/board/read';
import { langSessionStorage } from '@/lib/storage';
import ErrorRes from '@/api/server/ErrorRes';

export default function Notice() {
  const navigate = useNavigate();
  const [list, setList] = useState<resNoticeListProps[]>([]);
  useEffect(() => {
    (async () => {
      const paylaod: boardListProps = {
        board_type: 'notice',
        search_lang: langSessionStorage().lang,
      };
      const re = await boardList(paylaod);
      if (re.ret_code !== 200) {
        ErrorRes({ code: re.ret_code, msg: re.msg });
        return;
      }
      setList(re.data.list);
    })();

    return () => {};
  }, []);
  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '812px',
        // height: '100vh',
        position: 'relative',
      }}
    >
      <TopBackButton
        title="공지사항"
        boxProps={{
          mb: 4,
        }}
      />
      {/* <Typography
        variant="body1"
        sx={{
          color: SFPalette.grey2,
          wordBreak: "keep-all",
        }}
        mb={1}
      >
        안전한 자산 보호를 위해 최근 30일간의 로그인 정보를 제공합니다. 보안을
        위해 주기적으로 비밀번호를 변경해주세요!
      </Typography> */}
      <SFMenu.Menu>
        <Divider sx={{ mb: 0.5 }} />
        {list.map((item) => (
          <Fragment key={item.board_id}>
            <SFMenu.BetweenItem
              key={item.board_id}
              stackProps={{
                alignItems: 'center',
              }}
              onClick={() => {
                navigate(`/noticeDetail/${item.board_id}`);
              }}
              leftContent={
                <Stack>
                  <Typography variant="subtitle2">{item.title}</Typography>
                  <Typography sx={{ color: SFPalette.lightGrey2 }} variant="body2">
                    {item.reg_dt}
                  </Typography>
                </Stack>
              }
              rightContent={
                <ChevronRight
                  sx={{
                    color: SFPalette.lightGrey2,
                  }}
                />
              }
            />
            <Divider sx={{ my: 0.5 }} />
          </Fragment>
        ))}
      </SFMenu.Menu>
    </Container>
  );
}
